export default class Consts {
    static helloMessageTickSpeed = 150;
    static minimizeAnimationDuration = 200;

    static windowInstanceSize = {
        // Approximation
        height: 500,
        width: 650
    };

    static instanceType = {
        App: "App",
        Directory: "Directory"
    };

    static deviceType = {
        Mobile: "Mobile",
        Desktop: "Desktop"
    };

    static applications = {
        name: {
            "projects": "projects",
            "social": "social",
            "linkedin": "linkedin",
            "history": "history",
            "achivements": "achivements",
            "resumes": "resumes",
            "resumeElectronics": "resumeElectronics",
            "resumeProgramming": "resumeProgramming",
            "about": "about",
            "mail": "mail",
            "settings": "settings",
            "recycle bin": "recycle bin",
            "github": "github"
        },
        type: {
            "linkedin": "linkedin",
            "directory": "directory",
            "social": "directory",
            "projects": "projects",
            "history": "history",
            "achivements": "achivements",
            "resumes": "directory",
            "resumeElectronics": "resume",
            "resumeProgramming": "resume",
            "about": "about",
            "mail": "mail",
            "settings": "settings",
            "recycle bin": "recycle bin",
            "github": "github",
            "localDocument": "localDocument"
        },
        title: {
            "linkedin": "LinkedIn",
            "projects": "Projects",
            "social": "Social",
            "history": "History",
            "achivements": "Achievements",
            "resumes": "Resumes",
            "resumeElectronics": "Electronics - Resume",
            "resumeProgramming": "Programming - Resume",
            "about": "About me",
            "mail": "Mail",
            "settings": "Settings",
            "recycle bin": "Recycle bin",
            "github": "Github"
        },
        document: {
            "resume": "resume.pdf",
            "resumeProgramming" : "resume Banica Ninel-Valentin - Programming.pdf",
            "resumeElectronics" : "resume Banica Ninel-Valentin - Electronics.pdf",
        },
        documentName: {
            "resume": "Ninel-Valentin Bănică CV",
            "resumeProgramming": "Ninel-Valentin Bănică CV - Programming",
            "resumeElectronics": "Ninel-Valentin Bănică CV - Electronics"
        },
        foldable: {
            "projects": "projects",
            "history": "history",
            "achivements": "achivements"
        }
    };
};